<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2">
          <el-button
            class="goBack"
            style="width:150px"
            @click="goback()"
          >返回上一级</el-button>
        </el-col>
        <el-col :span="2" :offset="20">
          <el-button style="width:100px"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="场地管理"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="150px">
          <el-form-item label="时间类型" clearable prop="timetype">
            <el-select v-model="formparams.timetype" :disabled="disable" placeholder="请选择">
              <el-option v-for="item in this.timetypes"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提前可预约时长" prop="appointmenttime">
            <el-input class="w220" v-model="formparams.appointmenttime" :disabled="disable" placeholder="请输入提前可预约时长"></el-input>
          </el-form-item>
          <el-row v-if="formparams.timetype==0&&formparams.appointmenttime==0">
            <el-col :span="12">
              <el-form-item label="预约开始时间" prop="openTime">
                <el-time-picker
                  :disabled="disable"
                  v-model="formparams.openTime"
                  value-format="HH:mm:ss"
                  placeholder="预约开始时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预约结束时间" prop="closeTime">
                <el-time-picker
                  :disabled="disable"
                  v-model="formparams.closeTime"
                  value-format="HH:mm:ss"
                  placeholder="预约结束时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-form-item label="取消预约时间类型">
            <el-select v-model="formparams.cancleTimeType" clearable placeholder="请选择">
              <el-option v-for="item in this.timetypes2"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取消预约时长">
            <el-input class="w220" v-model="formparams.canceltime" placeholder="请输入取消预约时长"></el-input>
          </el-form-item>
          <el-form-item label="是否审批">
            <el-switch
              v-model="formparams.ifApprove"
              active-value= '1'
              inactive-value= '0'
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item label="退款百分比">
            <el-input class="w220" v-model.number="formparams.refundPercentage" placeholder="请输入退款百分比(1-100)"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column prop="appointmenttime" label="提前预约时间"></el-table-column> -->
        <el-table-column label="预约时间">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.timetype==0&&scope.row.appointmenttime>0">{{scope.row.appointmenttime}}天</span>
              <span v-else-if="scope.row.timetype==0&&scope.row.appointmenttime==0">当天</span>
              <span v-else-if="scope.row.timetype==1">{{scope.row.appointmenttime}}小时</span>
              <span v-else-if="scope.row.timetype==2">{{scope.row.appointmenttime}}分钟</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="预约时间段">
          <template slot-scope="scope">
              <span>{{scope.row.openTime}}-{{scope.row.closeTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="取消预约时间">
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.canceltime}}</span>
              <span v-if="scope.row.cancleTimeType==0">天</span>
              <span v-if="scope.row.cancleTimeType==1">小时</span>
              <span v-if="scope.row.cancleTimeType==2">分钟</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="退款百分比">
          <template slot-scope="scope">
            <div> {{scope.row.refundPercentage}} </div>
          </template>
        </el-table-column>
        <el-table-column label="场馆">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
        </el-table-column>
         <el-table-column label="项目">
          <template slot-scope="scope">
            <div> {{scope.row.shortname|className}} </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="danger" @click="remove(scope.row)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getTbAppointConfig, placeDeleteTbAppointConfig, insertTbAppointConfig, updateTbAppointConfig, placegetInfI, getShops } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      disable:false,
      addType:1,
      timetypes:[
        // {lable:'当天',value:2},
        {lable:'天',value:0},
        {lable:'小时',value:1},
        {lable:'分钟',value:2}
      ],
      timetypes2:[
        // {lable:'当天',value:2},
        {lable:'天',value:0},
        {lable:'小时',value:1},
        {lable:'分钟',value:2}
      ],
      date:[],//开始时间结束时间
      rules:{
        appointmenttime:[
          { required: true, message: '请输入提前预约时长', trigger: 'blur' }
        ],
        timetype:[
          { required: true, message: '请选择时间类型', trigger: 'change' }
        ],
        canceltime:[
          { required: true, message: '请输入取消预约时长', trigger: 'blur' }
        ],
        cancleTimeType:[
          { required: true, message: '请选择时间类型', trigger: 'change' }
        ],
        // openTime:[
        //   { required: true, message: '请选择预约开始时间', trigger: 'change' }
        // ],
        // closeTime:[
        //   { required: true, message: '请选择预约结束时间', trigger: 'change' }
        // ],
        refundPercentage:[
          { required: true, message: '请输入1-100的数字', trigger: 'blur' },
          { type: 'number', message: '百分比必须是数字且大于0'}
        ],
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      formparams:{
        appointmenttime:'',
        canceltime:'',
        timetype:'',
        cancleTimeType:'',
        refundPercentage:'',
        ifApprove: '0',
        type:this.$route.query.type,
        shortName:this.$route.query.shortName,
        shopNum:this.$route.query.shopNum,
        openTime:null,
        closeTime:null,
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    },
    className(value) {
      if (that.classProject.find(i => {
        return i.itemstyle == value
        })) {
        return that.classProject.find(i => {
            return i.itemstyle == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.placegetInfI()
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      for (let i = 0; i < this.shopList.length; i++) {
        this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
      }
    } else{
      this.getShopsList()
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    goback(){
      // this.$router.go(-1)
      this.$router.push({name:'siteList',query:{queryNum:this.$route.query.queryNum}})
    },
    placegetInfI(){
      placegetInfI().then((res)=>{
        // console.log(res)
        this.classProject = res.data
      })
    },
    getShopsList(){
      getShops().then((res)=>{
        this.shopList = res.data
        for (let i = 0; i < this.shopList.length; i++) {
          this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
        }
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
      })
    },
    //查询场地
    getTableList(){
      getTbAppointConfig({shortName:this.$route.query.shortName,type:this.$route.query.type,shopNum:this.$route.query.shopNum,}).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    },
    showDialog(){
        this.dialogVisible =true
        if(this.tableData[0]){
          this.formparams.appointmenttime = this.tableData[0].appointmenttime
          this.formparams.openTime = this.tableData[0].openTime
          this.formparams.closeTime = this.tableData[0].closeTime
          this.formparams.timetype = this.tableData[0].timetype
          this.disable=true
        }else{
          this.formparams.appointmenttime = ''
          this.formparams.openTime = null
          this.formparams.closeTime = null
          this.formparams.timetype = ''
          this.disable=false

        }
        // this.formparams.appointmenttime = ''
        // this.formparams.openTime = ''
        // this.formparams.closeTime = ''
        this.formparams.canceltime = ''
        // this.formparams.timetype = ''
        this.formparams.cancleTimeType = ''
        this.formparams.type = '1'
        this.formparams.refundPercentage = ''
        this.formparams.ifApprove = '0'
        this.addType = 1
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.appointmenttime = row.appointmenttime
      this.formparams.openTime = row.openTime

      this.formparams.closeTime = row.closeTime

      this.formparams.canceltime = row.canceltime
      this.formparams.timetype = row.timetype
      this.formparams.cancleTimeType = row.cancleTimeType
      this.formparams.type = '1'
      this.formparams.refundPercentage = row.refundPercentage
      this.formparams.ifApprove = row.ifApprove
      this.formparams.shopNum = row.shopnum
    },
    handleRemove(file) {
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          var appointmenttimeNum=''
          var canceltimeNum = ''
          // if(this.formparams.timetype == 0){
          //   if(this.formparams.appointmenttime==0){
          //     var endTime = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)
          //     var nowTime = new Date().getTime()
          //     appointmenttimeNum = parseInt(endTime-nowTime)/1000
          //    console.log(appointmenttimeNum)
          //   }else{
          //     appointmenttimeNum = parseInt(this.formparams.appointmenttime*24*60*60)
          //   }
          // } else if(this.formparams.timetype == 1){
          //   appointmenttimeNum = parseInt(this.formparams.appointmenttime*60*60)
          // } else{
          //   appointmenttimeNum = parseInt(this.formparams.appointmenttime*60)
          // }

          // if(this.formparams.cancleTimeType == 0){
          //   canceltimeNum = parseInt(this.formparams.canceltime*24*60*60)
          // } else if(this.formparams.cancleTimeType == 1){
          //   canceltimeNum = parseInt(this.formparams.canceltime*60*60)
          // } else{
          //   canceltimeNum = parseInt(this.formparams.canceltime*60)
          // }
          // console.log(canceltimeNum)
          // if(canceltimeNum>=appointmenttimeNum){
          //   this.$message.error('取消预约时长必须小于提前预约时长')
          //   return
          // }

          if(this.formparams.timetype != 0&&this.formparams.appointmenttime!=0){
            this.formparams.openTime = null
            this.formparams.closeTime = null
          }

          if(this.addType==1){
            insertTbAppointConfig(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'添加成功'
                  })
                }else{
                  this.$message.error(res.data);
                }
                this.getTableList()
            })
          } else {
            updateTbAppointConfig(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'修改成功'
                  })
                }else{
                 this.$message.error(res.data);
                }
                this.getTableList()
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    remove(row){
      // ticketId
      this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          placeDeleteTbAppointConfig({id:row.id}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'删除成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// siteYuyue.vue?6393d9b3